exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.standard-inner-input-style[data-v-aa48ecc8] {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.vue-input-tag-wrapper[data-v-aa48ecc8] {\n  padding: 0;\n  border: 0;\n  background-color: transparent;\n}\ninput[data-v-aa48ecc8] {\n  border: 0;\n  width: 100%;\n  outline: 0;\n  padding: 1px 3px;\n}\n.small[data-v-aa48ecc8] {\n  padding-top: 0!important;\n  padding-bottom: 0!important;\n}\n.hollow[data-v-aa48ecc8] {\n  border: 0!important;\n}\n.slimmer[data-v-aa48ecc8] {\n  padding: 0!important;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa48ecc8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/input/InputTags.vue
// module id = CB5B
// module chunks = 53